import { GET_NOTIFICATION_ALL, ADD_NOTIFICATION, SET_UNREAD_NOTIFICATION_STATUS } from './types';

const initialState = {
  allNotifications: [],
  unreadNotifications: {}
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATION_ALL:
      return {
        ...state,
        allNotifications: action.payload,
      };
    case ADD_NOTIFICATION:
      return {
        ...state,
        allNotifications: [action.payload,...state.allNotifications],
      };
    case SET_UNREAD_NOTIFICATION_STATUS:
      return {
        ...state,
        unreadNotifications: action.payload
      }
    default:
      return state;
  }
};

export default notificationReducer;
